import React from 'react';
import ReactDOM from 'react-dom';
import Application from 'components/Application';

ReactDOM.render(
  <React.StrictMode>
    <Application />
  </React.StrictMode>,
  document.getElementById('root')
);